import React from 'react';

export default function FullScreenLoader({ message = 'Please wait…', sub = '' }) {
  return (
    <div className="tx-overlay">
      <div className="spinner" />
      <div className="msg">{message}</div>
      {sub && <div className="sub">{sub}</div>}
    </div>
  );
}
